export const flag1 =  `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 502 502" style="enable-background:new 0 0 502 502;" xml:space="preserve">
<g>
<path style="fill:#E6E6E6;" d="M223.453,416.392c-14.499,0-26.253-11.754-26.253-26.253V36.253C197.2,21.754,208.954,10,223.453,10
   s26.253,11.754,26.253,26.253v353.887C249.706,404.638,237.952,416.392,223.453,416.392z"/>
<rect x="249.706" y="36.253" style="fill:#DB4949;" width="234.174" height="181.669"/>
<g>
   <path d="M285.409,322.162c-5.522,0-10,4.478-10,10s4.478,10,10,10h92.41c5.522,0,10-4.478,10-10s-4.478-10-10-10H285.409z"/>
   <path d="M483.88,26.253H258.292C253.939,11.113,239.974,0,223.453,0C203.463,0,187.2,16.263,187.2,36.253v285.909H98.039
       c-49.582,0-89.919,40.338-89.919,89.919S48.458,502,98.039,502h301.233c49.581,0,89.919-40.338,89.919-89.919
       c0-20.159-6.94-39.984-19.542-55.825c-12.39-15.575-29.764-26.759-48.919-31.49c-5.361-1.324-10.782,1.949-12.106,7.31
       c-1.324,5.362,1.948,10.782,7.31,12.106c31.357,7.746,53.258,35.667,53.258,67.899c0,38.554-31.365,69.919-69.919,69.919H98.039
       c-38.554,0-69.919-31.365-69.919-69.919s31.365-69.919,69.919-69.919H187.2v47.978c0,19.99,16.263,36.253,36.253,36.253
       s36.253-16.263,36.253-36.253V227.922H483.88c5.522,0,10-4.478,10-10V36.253C493.88,30.73,489.402,26.253,483.88,26.253z
        M239.706,390.14c0,8.962-7.291,16.253-16.253,16.253S207.2,399.102,207.2,390.14V36.253c0-8.962,7.291-16.253,16.253-16.253
       s16.253,7.291,16.253,16.253V390.14z M473.88,207.922H259.706V46.253H473.88V207.922z"/>
   <path d="M285.409,78.806h96.432c5.522,0,10-4.478,10-10s-4.478-10-10-10h-96.432c-5.522,0-10,4.478-10,10
       S279.887,78.806,285.409,78.806z"/>
   <path d="M421.343,78.806h27.884c5.522,0,10-4.478,10-10s-4.478-10-10-10h-27.884c-5.522,0-10,4.478-10,10
       S415.82,78.806,421.343,78.806z"/>
</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>`;